import { useEffect } from 'react';
import { AppBroadcastChannel, AppBroadcastEvents } from '../global';

export function useAppBroadcastSubscriber(chanel: AppBroadcastChannel = AppBroadcastChannel.AppChannel) {
  useEffect(() => {
    const channel = new BroadcastChannel(chanel);

    channel.onmessage = event => {
      if (event.data?.type === AppBroadcastEvents.PAGE_RELOAD) {
        window.location.href = `/`;
      }
    };

    return () => channel.close();
  }, [chanel]);
}
